import { css } from '@emotion/core';
// import { findLastIndex, unset } from 'lodash';
// import { colorsPalette } from '../../../styles/colors';
import { MediaQueries } from '../../../styles/Grid';
// import { typography, fontWeights } from '../../../styles/typography';
// import {
//   NAV_MAX_HEIGHT,
//   NAV_MAX_HEIGHT_SMALL_VIEWPORT,
// } from '../../../utils/constants';

export const containerSizesTop = {
  // position: 'fixed',
  // top: 0,
  // width: '100%',
  '.hero_img': {
    // maxHeight: '704px',
    width: '100%',
    objectFit: 'cover',

    [MediaQueries.sm]: {
      opacity: '0.2',
      width: '100%',
      height: '592px',
      objectFit: 'cover',
    },

    [MediaQueries.md]: {
      height: '544px',
      objectFit: 'cover',
    },
  },

  '.CTA-button': {
    color: '#fff',
    textDecoration: 'none',
    width: '196px',
    fontSize: '14px',
    lineHeight: '18px',
    letterSpacing: '0.875px',
    height: '56px',
    display: 'flex',
    textTransform: 'uppercase',
    justifyContent: 'center',
    alignItems: 'center',
    background: '#E52500',
    borderRadius: '8px',
  },

  '.CTA-button:hover': {
    background: '#d42705',
    outlineColor: '#d42705',
  },

  '.heroimg_content': {
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100%',
    paddingTop: '0',

    height: '100%',
    zIndex: 1,
    display: 'flex',

    [MediaQueries.sm]: {
      position: 'relative',
      padding: '0px 25px !important',
      marginTop: '-250px',
    },

    '.herobannerleft': {
      // height: '100vh',

      '.contentsec': {
        maxWidth: '650px',
        [MediaQueries.xl]: {
          maxWidth: '650px',
        },
        [MediaQueries.md]: {
          maxWidth: '370px',
        },
        [MediaQueries.lg]: {
          maxWidth: '496px',
        },
      },

      [MediaQueries.sm]: {
        background: 'transparent',
        height: 'auto',
      },
      [MediaQueries.md]: {},
    },
  },

  [MediaQueries.sm]: {
    paddingBottom: '0px',
    paddingTop: '0px',
  },

  '.callsectionbg': {
    paddingBottom: '32px',
    '.callsec': {
      minHeight: '120px',
      justifyContent: 'space-between',
      background: 'rgba(255, 255, 255)',
      backdropFilter: 'blur(24px)',
      borderRadius: '8px',
      display: 'flex',
      flexDirection: 'row',
      padding: '32px',
      [MediaQueries.sm]: {
        flexDirection: 'Column',
      },
      [MediaQueries.md]: {
        flexDirection: 'Column',
      },

      '.expert_call': {
        display: 'flex',
        [MediaQueries.md]: {
          marginBottom: '30px',
        },
        [MediaQueries.sm]: {
          marginBottom: '0px',
          flexDirection: 'Column',
        },
      },
      '.callusnow': {
        marginRight: '50px',
        [MediaQueries.md]: {
          marginRight: '40px',
        },

        '.callustxt': {
          fontSize: '18px',
          lineHeight: '32px',
          letterSpacing: '0px',
          textAlign: 'left',
          fontWeight: 500,
        },
        '.callnowithicon': {
          display: 'flex',
          paddingTop: '5px',
          alignItems: 'center',

          '.phone-number': {
            margin: '0 16px 0 10px',
            fontSize: '22px',
            lineHeight: '32px',
            letterSpacing: '-0.30000001192092896px',
            textAlign: 'left',
            fontWeight: '300',
          },
        },
      },
    },

    '.or_line': {
      borderLeft: '2px solid #393939',
      opacity: '0.5',
      marginRight: '46px',
      [MediaQueries.sm]: {
        marginTop: '15px',
        marginbottom: '15px',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        border: '0',
      },
      span: {
        position: 'relative',
        background: '#fff',
        backdropFilter: 'blur(24px)',
        left: '-12px',
        padding: '3px 0px',
        alignItems: 'center',
        display: 'flex',
        top: '35%',
        bottom: '50%',
      },
    },

    '.talktoexpert': {
      marginRight: '50px',
      marginTop: '5px',
      [MediaQueries.sm]: {
        marginBottom: '15px',
      },
      '.callustxt': {
        fontSize: '18px',
        lineHeight: '32px',
        letterSpacing: '0px',
        textAlign: 'left',
        fontWeight: 500,
        [MediaQueries.sm]: {
          fontSize: '16px',
        },
      },
      '.callnowithicon': {
        display: 'flex',
        paddingTop: '5px',
        alignItems: 'center',

        p: {
          fontSize: '14px',
          lineHeight: '24px',
        },

        '.phone-number': {
          margin: '0 16px 0 10px',
          fontSize: '22px',
          lineHeight: '32px',
          letterSpacing: '-0.30000001192092896px',
          textAlign: 'left',
          fontWeight: '300',
        },
      },
    },

    '.callme': {
      form: {
        display: 'flex',
        alignItems: 'center',

        [MediaQueries.sm]: {
          flexDirection: 'Column',
        },
        '.phonenofield': {
          div: {
            maxWidth: '300px',
            padding: '10px 16px',
          },
        },
      },
      input: {
        width: '100%',
        borderRadius: '4px',
      },

      button: {
        minWidth: '255px',
        background: '#E52500',
        border: '0',
        color: '#fff',
        height: '51px',
        marginLeft: '32px',
        fontSize: '14px',
        borderRadius: '8px',
        lineHeight: '18px',
        letterSpacing: '0.875px',
        textAlign: 'center',

        [MediaQueries.sm]: {
          marginLeft: '0px',
          marginTop: '16px',
          marginBottom: '16px',
          padding: '20px',
        },
      },
    },
  },
};

export const FeatureBulletLink = {};

export const containerCss = css({
  position: 'relative',
  zoom: 1,
  height: '100%',
  width: '100%',
});

export const featureherosec = {
  position: 'relative',
  height: '100%',
  // width: '100%',

  minHeight: 813,
  [MediaQueries.lg]: {
    minHeight: 813,
    width: '100%',
    paddingBottom: '80px',
    paddingTop: '80px',
  },
  [MediaQueries.md]: {
    minHeight: 814,
    width: '100% !important',
    minHeight: 840,
  },
  [MediaQueries.sm]: { width: '100% !important' },

  '.content-holder': { fontSize: '16px' },
  '.shadow_tab': {
    display: 'none',
    position: 'absolute',
    width: '100%',
    zIndex: '2',
    bottom: 0,
    height: '88px',
    [MediaQueries.lg]: {
      display: 'block',
    },
    [MediaQueries.md]: {
      display: 'block',
    },

    [MediaQueries.sm]: {
      display: 'block',
      bottom: '0',
    },
  },
};

export const DarkModeCss = css({
  [MediaQueries.sm]: {
    background: '#393939',
  },
  [MediaQueries.lg]: {
    background: '#393939',
  },
  [MediaQueries.md]: {
    background: '#393939',
  },

  '.shadow_tab': {
    background: 'linear-gradient(0deg,#393939 0%,rgba(57,57,57,0) 100%)',
  },
});

export const LightModeCss = css({
  [MediaQueries.sm]: {
    background: '#f4f3f0',
  },
  [MediaQueries.lg]: {
    background: '#f4f3f0',
  },
  [MediaQueries.md]: {
    background: '#f4f3f0',
  },

  '.shadow_tab': {
    background: 'linear-gradient(0deg,#f4f3f0 0%,rgba(244,243,240,0) 100%)',
  },
});

export const bannerImageHolder = css({
  position: 'relative',
  zoom: 1,
  [MediaQueries.sm]: {
    position: 'absolute',
  },
});

export const scrollmeDarkModeCss = css({
  [MediaQueries.sm]: {},
});
export const scrollmeLightModeCss = css({
  [MediaQueries.sm]: {
    marginTop: '44px',
  },
});
export const CommonCss = css({
  // transition: 'all 300ms linear',
  background: '#efefef',

  // height: '100vh',
  // maxHeight: 825,
  // [MediaQueries.xl]: { marginTop: -96 },
  // [MediaQueries.lg]: { marginTop: -96 },
  // [MediaQueries.md]: { marginTop: -96 },
  // [MediaQueries.sm]: { marginTop: -74 },
  // [MediaQueries.lg]: {
  //   height: '100vh',
  // },
  // [MediaQueries.md]: {
  //   height: '100vh',
  // },

  // [MediaQueries.sm]: {
  //   height: 'auto',
  //   maxHeight: 'none',
  // },

  '.bg-gradient': {
    position: 'absolute',
    width: '100%',
    height: '100%',
    zIndex: 1,
  },
});
const scrollAreaIpadCss = {
  // float: 'right',
  position: 'absolute',
  marginRight: '44px',
  width: 'fit-content',
  // marginTop: '304px',
  zIndex: 2,
  // WebkitTransition: 'all 100ms linear',
  // transition: 'all 100ms linear',
  bottom: 48,
};
export const scrollAreaIpad = css(scrollAreaIpadCss);

export const scrollAreaMobile = css({
  float: 'none',
  position: 'relative',
  width: '100%',
  margin: '0px',
  zIndex: 'unset',
  // WebkitTransition: 'all 100ms linear',
  // transition: 'all 100ms linear',
  bottom: 0,
  height: 'fit-content',
  [MediaQueries.sm]: {
    zIndex: '1',
  },
});

export const scrollShadow = cssObjVal =>
  css({
    position: 'absolute',
    zIndex: 9999,
    // transition: 'opacity 300ms linear',
    opacity: 0,
    marginRight: '4%',
    right: 0,

    [MediaQueries.xl]: {
      // marginTop: '75%',
      marginRight: '112px',
    },

    [MediaQueries.lg]: {
      // marginTop: '75%',
      marginRight: '44px',
    },

    [MediaQueries.md]: {
      // marginTop: '208px',
      marginRight: '48px',
    },

    [MediaQueries.sm]: {
      display: 'none',
    },
    // background:
    //   'linear-gradient(\n180deg\n, rgba(255, 255, 255, 0) 0%, #FFFFFF 100.09%)',
    ...cssObjVal,
  });

export const HeroHolder = css({
  position: 'absolute',
  // overflow: 'auto',
  top: 0,
  height: '100%',
  width: '100%',

  [MediaQueries.sm]: {
    position: 'relative',
  },
});

export const itemsContainerCss = css({
  paddingBottom: '0px',
  paddingTop: '0px',

  '.bulletimg': {
    margin: '160px 0',
  },

  '.imgsec': {
    marginLeft: '8.333333333333332%',
    marginRight: '8.333333333333332%',

    '.img1': {
      width: '100%',
    },
    '.img2': {
      position: 'absolute',
      top: '272px',
      left: '281px',
      width: '100%',
    },
    img: {},
  },
});
/*********************** */
/*********************** */
/*********************** */
export const RelativePositionCss = css({
  height: '100%',
  position: 'relative',
  overflow: 'inherit',
  background: '#fff',
  zIndex: 1,
  zoom: 1,
});

export const RelativePositionLightModeCss = css({
  [MediaQueries.sm]: {
    background: '#f4f3f0',
    paddingBottom: '33px',
  },
});

export const RelativePositionDarkModeCss = css({
  [MediaQueries.sm]: {
    background: '#393939',
    paddingBottom: '33px',
  },
});

export const floatingArea = css({
  position: 'relative',
  width: '50%',
  height: 'auto',
  top: 0,

  [MediaQueries.md]: {
    position: 'relative',
    display: 'inline-flex',
  },
  [MediaQueries.sm]: {
    width: '100%',
    padding: '0px 24px',

    position: 'relative',
    display: 'flex',
  },
});

export const imageBlock = css({
  zIndex: 1,
  position: 'relative',
  // height: 816,
  img: {
    width: '100%',
  },
  // minHeight: 813,
  [MediaQueries.lg]: {
    // minHeight: 813,
  },
  [MediaQueries.md]: {
    overflow: 'hidden',
    position: 'absolute',
    // minHeight: 'auto',
  },
  [MediaQueries.sm]: {
    position: 'absolute',
    overflow: 'hidden',
    // minHeight: 'auto',
  },
});
export const titleBlockHolder = css({
  zIndex: 3,
  top: 96,

  [MediaQueries.md]: {
    verticalAlign: 'top',
  },
  [MediaQueries.sm]: {
    top: 'unset',
    // marginTop: 81,
    padding: '72px 24px 0',
  },
});

export const scrollMeHolder = visibility =>
  css({
    zIndex: 2,
    right: 0,
    height: '100%',
    overflow: 'hidden',
    // visibility: visibility,
    // transition: 'all 300ms linear',
    // opacity: 0,
    opacity: visibility === 'visible' ? 1 : 0,

    [MediaQueries.md]: {
      // opacity: '0',
    },
    [MediaQueries.sm]: {
      position: 'relative',
      zIndex: 'unset',
      opacity: '1',
      overflow: 'inherit',
      padding: '40px 24px 0',
    },
  });
export const scrollArea = css({
  position: 'absolute',
  right: 0,
  // marginRight: '4%',
  width: 'fit-content',
  // marginTop: '75%',
  bottom: '-34%',
  zIndex: 2,
  transition: 'all 300ms linear',

  [MediaQueries.xl]: {
    // bottom: '34%',
    marginRight: '112px',
  },

  [MediaQueries.lg]: {
    // bottom: '34%',
    marginRight: '44px',
  },

  [MediaQueries.md]: {
    // marginTop: '208px',
    marginRight: '48px',

    ...scrollAreaIpadCss,
  },

  [MediaQueries.sm]: {
    // marginTop: '0px !important',
    float: 'none',
    marginRight: '0',
    width: '100%',
    position: 'relative',
  },
});

export const gridContainer = css({
  position: 'absolute',
  top: 0,
  width: '100%',
  height: '100%',
  display: 'flex',
  [MediaQueries.sm]: {
    display: 'block',
    position: 'relative',
  },
});
